import { render } from "./ShowParticipant.vue?vue&type=template&id=35883f35&scoped=true"
import script from "./ShowParticipant.vue?vue&type=script&lang=js"
export * from "./ShowParticipant.vue?vue&type=script&lang=js"

import "./ShowParticipant.vue?vue&type=style&index=0&id=35883f35&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35883f35"

export default script